import { render, staticRenderFns } from "./transferBall.vue?vue&type=template&id=7bd4c192&scoped=true&lang=html&"
import script from "./transferBall.vue?vue&type=script&lang=js&"
export * from "./transferBall.vue?vue&type=script&lang=js&"
import style0 from "./transferBall.vue?vue&type=style&index=0&id=7bd4c192&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd4c192",
  null
  
)

component.options.__file = "transferBall.vue"
export default component.exports